import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import classes from './formHeader.module.css';

const FormHeader = ({ text, children = null }) => {
    return (
        <div className={children && classes.headerAsContainer}>
            <Typography variant="h5" sx={{ paddingBottom: '20px' }}>
                {text}
            </Typography>
            {children}
        </div>
    );
};

FormHeader.propTypes = {
    text: PropTypes.string,
    children: PropTypes.node,
};

export default FormHeader;
